import script from "./status-show.vue?vue&type=script&setup=true&lang=js"
export * from "./status-show.vue?vue&type=script&setup=true&lang=js"

import "./status-show.vue?vue&type=style&index=0&id=6c2aea2a&lang=scss&scoped=true"
import "./status-show.vue?vue&type=style&index=1&id=6c2aea2a&lang=scss"

import exportComponent from "D:\\Work\\tatu\\tatu_25_5_24\\3.1源代码_25_4_3\\前端-源代码\\smart-battery-web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6c2aea2a"]])

export default __exports__